import React, { useEffect, useState } from 'react';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { colors, styled } from '../../assets/theme';

interface IAdvancerDeclinerData {
  idx?: number,
  d?: number,
  a?: number,
}

export const AdvancerDecliner: React.FunctionComponent<{id: number}> = ({ id }) => {
  const [advdec, setAdvdec] = useState<IAdvancerDeclinerData>({ idx: 0, a: 1, d: 1});
  useEffect(() => {
    subscribeListener('adv:ADSPX:tick', id, ({ data }) => {
      setAdvdec(data);
    });
    return () => unsubscribeListener('adv:ADSPX:tick', id);
  }, [id]);
  const { d, a } = advdec
  if (d === undefined || a === undefined) { return <div /> }
  return (
    <div style={{ height: '100%' }}>
      <Container key={advdec.idx}>
        <span>{d}</span>
        <OuterBar>
          <InnerBar barWidth={(d / (a + d)) * 100} />
        </OuterBar>
        <span>{a}</span>
      </Container>
    </div>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr 100px;
  justify-items: center;
  height: 100%;
  align-items: center;
`;

const OuterBar = styled.div`
  width: 100%;
  background: ${colors.accents.good.base};
  height: 1.5em;
`;

const InnerBar = styled.div<{barWidth: number}>`
  width: ${({ barWidth }) => barWidth}%;
  background: ${colors.accents.bad.base};
  height: 100%;
  border-right: solid 2px ${({ theme }) => theme.core.lightBackground};
`;
